import { arrayOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isUsersSubscriptionGroupStatsResult = objectOf({
  ts: objectOf({
    subscribed: arrayOf(arrayOf(number)),
    unsubscribed: arrayOf(arrayOf(number)),
  }),
});
